import { render, staticRenderFns } from "./digital_list.vue?vue&type=template&id=ea0450c8&scoped=true"
import script from "./digital_list.vue?vue&type=script&lang=js"
export * from "./digital_list.vue?vue&type=script&lang=js"
import style0 from "./digital_list.vue?vue&type=style&index=0&id=ea0450c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0450c8",
  null
  
)

export default component.exports